import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import WhatIsMulebuySpreadsheet from "../pages/articles/WhatIsMulebuySpreadsheet";
import HowMulebuySpreadsheetWorks from "../pages/articles/HowMulebuySpreadsheetWorks";
import BestMulebuySpreadsheetTools from "../pages/articles/BestMulebuySpreadsheetTools";
import IsMulebuySpreadsheetSafe from "../pages/articles/IsMulebuySpreadsheetSafe";
import MulebuySpreadsheetVsAgents from "../pages/articles/MulebuySpreadsheetVsAgents";
import BeginnerGuideMulebuySpreadsheet from "../pages/articles/BeginnerGuideMulebuySpreadsheet";
import HowToUseMulebuySpreadsheetEfficiently from "../pages/articles/HowToUseMulebuySpreadsheetEfficiently";
import BestPracticesMulebuySpreadsheet from "../pages/articles/BestPracticesMulebuySpreadsheet";
import MulebuySpreadsheetPricing from "../pages/articles/MulebuySpreadsheetPricing";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/what-is-mulebuy-spreadsheet",
    element: <WhatIsMulebuySpreadsheet />,
  },
  {
    path: "/how-mulebuy-spreadsheet-works",
    element: <HowMulebuySpreadsheetWorks />,
  },
  {
    path: "/best-mulebuy-spreadsheet-tools",
    element: <BestMulebuySpreadsheetTools />,
  },
  {
    path: "/is-mulebuy-spreadsheet-safe",
    element: <IsMulebuySpreadsheetSafe />,
  },
  {
    path: "/mulebuy-spreadsheet-vs-agents",
    element: <MulebuySpreadsheetVsAgents />,
  },
  {
    path: "/beginner-guide-mulebuy-spreadsheet",
    element: <BeginnerGuideMulebuySpreadsheet />,
  },
  {
    path: "/how-to-use-mulebuy-spreadsheet-efficiently",
    element: <HowToUseMulebuySpreadsheetEfficiently />,
  },
  {
    path: "/best-practices-mulebuy-spreadsheet",
    element: <BestPracticesMulebuySpreadsheet />,
  },
  {
    path: "/mulebuy-spreadsheet-pricing",
    element: <MulebuySpreadsheetPricing />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;